import React, { Component } from "react";
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import { Field, reduxForm } from 'redux-form';

import { getProgramDetails, saveProgram } from './actions/programActions';
import { renderTextField } from '../../../../../components/reduxFields';
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../../../components/buttons';
import SmallLoader from '../../../../../img/small-loader.gif';
import validate from './validate';
import { checkFieldExistence, clearFieldErrorArray } from '../../../../AppConfig/actions';
import { MODULE } from './constants/ApiConstants';
import { displayCustomError } from '../../../../../actions/utilAction';



class ProgramModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      domainId: props.domainId,
      programId: props.programId,
      patientId: props.patientId || 0
    };
  }

  componentWillMount() {
    if (this.state.programId) {
      this.props.getProgramDetails(this.state.programId);
    }
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    if (this.state.open) {
      this.props.clearFieldErrorArray();
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };

  componentWillReceiveProps(nextProps) {
    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };

  }

  renderLoading() {
    return (
      <div>
        {this.props.loading ? (
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  async onSubmitHandler(formProps) {
    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }
    let postData = {
      "id": this.props.programId || 0,
      "domainId": this.state.domainId,
      "programName": formProps.programName,
      "patientId": this.state.patientId,
      // "isActive":  formProps.isActive || false
      "isActive":  this.props.isActive
    }
    this.props.clearFieldErrorArray();
    try{
      await this.props.saveProgram(postData);
      this.setState({ open: false });
      this.props.closeDialog();
      this.props.loadProgramsData();
    }catch(error){
      console.error("Error saving program:", error);
    }
  }

  checkFieldDataExistence = (input, value, labelName) => {
    if (value.length > 0) {
      let postData = {
        "AdditionalColmnId":this.props.domainId,
        'labelName': labelName,
        'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
        'value': value.trim(),
        'colmnName': input.target.name.toUpperCase(),
        'id': this.state.programId || 0,
        'patientId': this.state.patientId ? parseInt(this.state.patientId) : 0,
      };
      this.props.checkFieldExistence(postData);
    }
  };

  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  };

  render() {
    const { handleSubmit } = this.props;
    let submitButton = this.props.loading ?
    <SubmitButtonModalDisabled label="Loading" /> :
    <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
    const actions = [
        <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
        submitButton,
      ];
    return (
      <Dialog
        className="custom_modal"
        title={
          this.state.programId
            ? "Edit Program"
            : "Add Program"
        }
        modal={false}
        open={this.state.open}
        actions={actions}
        autoScrollBodyContent={true}
      >
        {this.renderLoading()}
        <div className="row">
          <div className="col-sm-12">
            <form
              className="readmin-form custom_form"
              onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}
            >
              <div className="row">
                <div className="col-sm-12 require">
                  <Field
                    autoFocus={true}
                    name="programName"
                    type="text"          
                    onChange={(input, value) => this.checkFieldDataExistence(input, value, 'Program Name')}
                    customError={displayCustomError('PROGRAMNAME', this.props.fieldError)}        
                    maxLength="250"
                    label="Program Name"
                    // normalize={isValidNameWithSpace}
                    component={renderTextField}
                  />
                </div>
              </div>
              {/* <div className="row">
                <div className="col-sm-3">
                  <Field
                    className="mt20 mb0"
                    name="isActive"
                    label="Is Active"
                    component={renderCheckBox}
                  />
                </div>
              </div> */}
            </form>
          </div>
        </div>
      </Dialog>
    );
  }
}

ProgramModal = reduxForm({
    form: 'ProgramModalForm',
    validate,
    enableReinitialize: true,
})(ProgramModal);


function mapStateToProps(state, ownProps) { 

  let initialValueData = {
    //isActive: true,
  };
  if (ownProps.programId && state.program.programListDetails) {
    initialValueData = state.program.programListDetails.data || null;
  } 

  return {
    loading: state.program.loading,
    fieldError: state.appConfig.fieldError,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
    initialValues: initialValueData,
    isActive: ownProps.programId && state.program.programListDetails && state.program.programListDetails.data ? state.program.programListDetails.data.isActive : 0,
  }
}

export default connect(mapStateToProps,{getProgramDetails, checkFieldExistence, clearFieldErrorArray, saveProgram})(ProgramModal);



// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/curriculumLibraries/components/program/program_Modal.js